export default __webpack_public_path__ + "img/f2872bf89a2c9dbb8701ba8d00df186e.svg";